import { useMutation } from '@tanstack/react-query';
import { integrationHubApi } from '../api/integrationHubApi';
import type { PresignResultDto } from '../types/integrationHub';

/**
 * POST /api/eraf/integration-hub/storage/files/{fileId}/presign — presign URL 생성 (INTEGRATION_INVOKE)
 * local/sftp backend 에서는 INTGHUB-501-001 반환 (graceful)
 */
export function usePresign() {
  return useMutation<PresignResultDto, { code: string; message: string }, string>({
    mutationFn: (fileId) => integrationHubApi.presignFile(fileId),
  });
}
